import { render } from "./PriceFilter.vue?vue&type=template&id=0195b231"
import script from "./PriceFilter.vue?vue&type=script&lang=js"
export * from "./PriceFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__